{
  "version": "2026-07-28-01",
  "enabled": true,
  "rules": {
    "claude-opus-4-5-20251101": "Venus-Marble-4-5-20251101",
    "claude-opus-4-1-20250805": "Venus-Marble-4-1-20250805",
    "claude-opus-4-20250514": "Venus-Marble-4-20250514",
    "claude-haiku-4-5-20251001": "Venus-Sketch-4-5-20251001",
    "claude-sonnet-4-5-20250929": "Venus-Fresco-4-5-20250929",
    "claude-fable-5": "Venus-Cathedral-5",
    "Opus": "Marble",
    "Sonnet": "Fresco",
    "Haiku": "Sketch",
    "Fable": "Cathedral"
  }
}
